import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useStudentAuth } from "../../context/StudentAuthContext";
import logo from "../../assets/logo.png";

export default function StudentSignup() {
  const { signup } = useStudentAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const result = await signup(form);
      navigate("/student/verify-otp", {
        replace: true,
        state: { email: result.email, from: location.state?.from },
      });
    } catch (err) {
      setError(err.friendlyMessage || "Could not create your account.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pm-auth-shell">
      <motion.div
        className="pm-auth-card"
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <Link to="/" className="pm-auth-brand">
          <img src={logo} alt="Positive Moves" className="pm-brand-logo" />
        </Link>
        <h1>Create your account</h1>
        <p className="pm-auth-sub">One login covers every campus you apply to.</p>

        <form onSubmit={handleSubmit} className="pm-auth-form">
          <div className="pm-field">
            <label>Full name</label>
            <input required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} />
          </div>
          <div className="pm-field">
            <label>College email ID</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@university.edu" />
            <span className="pm-field__hint">This is used to log in, and auto-fills your college email on every application.</span>
          </div>
          <div className="pm-field">
            <label>Phone (optional)</label>
            <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          </div>
          <div className="pm-field">
            <label>Password</label>
            <input type="password" required minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <span className="pm-field__hint">At least 8 characters.</span>
          </div>
          {error && <div className="pm-form-error">{error}</div>}
          <button className="pm-btn pm-btn--primary pm-btn--lg" disabled={loading} type="submit">
            {loading ? "Creating account…" : "Create account"}
          </button>
        </form>

        <p className="pm-auth-switch">
          Already have an account? <Link to="/student/login">Log in</Link>
        </p>
      </motion.div>
    </div>
  );
}